/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface PrintStyles {
    showOnPrint: StyledProp<any>;
    hideOnPrint: StyledProp<any>;
    avoidBreakInside: StyledProp<any>;
}

const printStyles: PrintStyles = {
    showOnPrint: css`
        @media not print {
            display: none;
        }
    `,
    hideOnPrint: css`
        @media print {
            display: none;
        }
    `,
    avoidBreakInside: css`
        @media print {
            break-inside: avoid;
            page-break-inside: avoid;
            column-break-inside: avoid;
        }
    `,
};

export function onPrint(cssProp: StyledProp<any>): StyledProp<any> {
    return css`
        @media print {
            ${cssProp}
        }
    `;
}

export function onNotPrint(cssProp: StyledProp<any>): StyledProp<any> {
    return css`
        @media not print {
            ${cssProp}
        }
    `;
}

export default printStyles;
